import { CATEGORY_HUE_COUNT } from '@recipes/contracts';
import { foldText } from '../text/normalize.js';
/**
 * Colour with a meaning (docs/partial/appearance-and-themes-spec.md 6.4): what maps to which of
 * the ten category hues (`--color-cat-1 … -10`). A stable table, not a hash – "produce" is green
 * in every theme and on every device.
 *
 * 1 green · 2 red · 3 blue · 4 amber · 5 cyan · 6 yellow · 7 orange · 8 purple · 9 teal · 10 pink
 */
const GROCERY_HUES = {
    produce: 1,
    bakery: 4,
    meat_fish: 2,
    dairy_eggs: 3,
    frozen: 5,
    baking_goods: 6,
    pasta_rice: 7,
    canned: 9,
    oils_sauces: 1,
    spices: 2,
    breakfast: 4,
    snacks: 10,
    pantry: 6,
    beverages: 3,
    alcohol: 8,
    drugstore: 5,
    household: 9,
    pet: 8,
    // "Other" says nothing – it stays neutral.
    other: null,
};
const MEAL_TYPE_HUES = {
    breakfast: 6,
    brunch: 7,
    lunch: 1,
    dinner: 3,
    snack: 9,
    dessert: 10,
    appetizer: 5,
    side: 4,
    drink: 8,
    sauce: 2,
    baking: 4,
};
const MEAL_SLOT_HUES = {
    BREAKFAST: 6,
    LUNCH: 1,
    DINNER: 3,
    SNACK: 9,
    CUSTOM: 8,
};
/** The hue of a department; null for "other" and for codes this build does not know. */
export function groceryCategoryHue(category) {
    return GROCERY_HUES[category] ?? null;
}
export function mealTypeHue(mealType) {
    return mealType ? (MEAL_TYPE_HUES[mealType] ?? null) : null;
}
export function mealSlotHue(slot) {
    return MEAL_SLOT_HUES[slot] ?? MEAL_SLOT_HUES.CUSTOM;
}
/**
 * A hue for something that has only a name (a tag, a collection, a recipe category): derived
 * from the folded name, so "Pasta" and "pasta " get the same colour on every device, always.
 */
export function hueFromName(name) {
    const text = foldText(name);
    let hash = 0;
    for (let i = 0; i < text.length; i += 1)
        hash = (hash * 31 + text.charCodeAt(i)) >>> 0;
    return ((hash % CATEGORY_HUE_COUNT) + 1);
}
/** The hue somebody picked, else the one derived from the name. */
export function chosenHue(color, name) {
    return color && Number.isInteger(color) && color >= 1 && color <= CATEGORY_HUE_COUNT
        ? color
        : hueFromName(name);
}
/**
 * The hue of a recipe without a photo: its meal type, else its first category, else its title –
 * the same recipe looks the same in the list, on a card, in the meal plan and in a chip.
 */
export function recipeHue(recipe) {
    const first = recipe.categories?.[0];
    return (mealTypeHue(recipe.mealType) ??
        (first ? hueFromName(first.slug ?? first.id) : null) ??
        hueFromName(recipe.title));
}
//# sourceMappingURL=category-hues.js.map